const o = {
  none: 0,
  "1px": "1px solid"
};
export {
  o as default
};
